// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3lNJb","modalForm":"UpgradeEpcsModal_modalForm__24y6Q","modalFooter":"UpgradeEpcsModal_modalFooter__1b4UM"};